import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { ArrowUpFromLine, ArrowDownToLine } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { StatsGrid, StatsItemContainer, StatsInfo } from './styles';

interface FieldValueDetail {
  value: string | number | boolean;
  writable: number;
}

interface NetworkInterfaceValues {
  [key: string]: FieldValueDetail | undefined;
}

function StatsData({
  fieldValues,
  translatePath,
}: {
  fieldValues: NetworkInterfaceValues | undefined;
  translatePath: string;
}) {
  const theme = useTheme();
  const statsFields = [
    'bytesSent',
    'bytesReceived',
    'packetsSent',
    'packetsReceived',
    'errorsSent',
    'errorsReceived',
  ];
  const { t } = useTranslation();

  function getColorByStats(stats: string) {
    if (stats.includes('errors')) {
      return theme.palette.error.main;
    } else if (stats.includes('bytes')) {
      return theme.palette.primary.main;
    } else if (stats.includes('packet')) {
      return theme.palette.secondary.main;
    } else return undefined;
  }

  return (
    <Box width="100%" mt={4}>
      <StatsGrid>
        {statsFields.map((field) => (
          <StatsItemContainer key={field}>
            {field.includes('Sent') ? (
              <ArrowUpFromLine size={28} color={getColorByStats(field)} />
            ) : (
              <ArrowDownToLine size={28} color={getColorByStats(field)} />
            )}

            <StatsInfo>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  textAlign: 'center',
                }}
              >
                {fieldValues &&
                fieldValues[field] !== undefined &&
                fieldValues[field] !== null
                  ? (fieldValues[field]?.value ?? 'N/A')
                  : 'N/A'}
              </Typography>

              <Typography
                sx={{ fontWeight: 300, fontSize: '12px', textAlign: 'center' }}
              >
                {t(`${translatePath}.${field}`)}
              </Typography>
            </StatsInfo>
          </StatsItemContainer>
        ))}
      </StatsGrid>
    </Box>
  );
}

export default StatsData;
